<template>
  <button class="smart button" :disabled="disabled">
    <div v-if="icon" class="icon-box">
      <slot name="icon" :icon="icon">
          <img :src="icon"/>
      </slot>
    </div>
    <div class="label-box">
      <slot :label="currentLabel">{{currentLabel}}</slot>
    </div>
  </button>
</template>

<script>
export default {
  props:{
      label: {
          type: String,
          default: null,
      },
      labelDisabled: {
          type: String,
          default: null,
      },
      disabled:{
          type: Boolean,
          default: false,
      },
      icon: {
          type: String,
          default: null,
      },
  },
  computed:{
      currentLabel(){
          return this.disabled && this.labelDisabled ? this.labelDisabled : this.label;
      }
  },
  name: "Smart-Button"
};
</script>

<style>
.smart.button {
  --icon-width: 24px;
  --icon-height: var(--icon-width);

  display: flex;
}

.smart.button > .label-box {
  flex: 1;
  vertical-align: center;
  align-self: center;
}

.smart.button > .icon-box{
  width: var(--icon-width);
  height: var(--icon-height);
}
</style>

